import qs from "qs";

interface Result {
    url: string;
    width?: number;
    height?: number;
}

export default function parseImageUrl(url: string) {
    const result = {
        url,
    } as Result;
    const queryStrings = /\?.*/.exec(url);

    if (queryStrings) {
        const urlWithoutQuery = url.slice(0, queryStrings.index);
        const obj = qs.parse(queryStrings[0], { ignoreQueryPrefix: true });

        result.height = obj.height;
        result.width = obj.width;

        delete obj.width;
        delete obj.height;
        result.url = urlWithoutQuery;
        if (Object.keys(obj).length > 0) {
            result.url = `${urlWithoutQuery}?${qs.stringify({ ...obj })}`;
        }
    }
    return result;
}
